import React from "react";
import Chart from "react-apexcharts";

function ChartJobCat(prop) {
    if (prop.data != undefined) {
        const display = [];
        const setData = [];
        for (let i = 0; i < prop.data.length; i++) {
          setData.push(prop.data[i].counter);
          display.push(prop.data[i].job_category_name);
        }
        const series = [
            {
              data: setData,
            },
          ];
        const options = {
          plotOptions: {
            bar: {
              horizontal: true,
            },
          },
          dataLabels: {
            enabled: true,
          },
          xaxis: {
            categories: display,
          },
        };
    return(
         <Chart options={options} series={series} type="bar" height={350}/>
    )
       
      }
    else{
        return(false)
    }
}

export default ChartJobCat














